enum GlobalMessageType {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
}

type GlobalMessage = {
  type?: GlobalMessageType;
  message: string;
};

export { GlobalMessageType };
export type { GlobalMessage };
